export default __webpack_public_path__ + "static/footer-7341d363c7d1385570aade40594e000f.png";